export function assignIpAddress(
  compontentsData,
  defaultIpAddress,
  CBAssetList = [],
  CBLoadList = [],
  CBEVList = [],
  assetDefaultValues
) {
  let ipCount = 1;
  const indexes = groupCB(
    compontentsData,
    CBAssetList,
    CBLoadList,
    CBEVList,
    assetDefaultValues
  );
  let cBMBData = assetDefaultValues?.["Circuit Breaker"];
  let ipIterated = true;
  for (let data in indexes) {
    const value = indexes?.[data]?.cbValue;
    let modCount = 0;
    let doModBusChange = false;
    indexes?.[data]?.cbArray?.forEach((item, index) => {
      if (
        compontentsData[item]?.componentType === "Circuit Breaker" &&
        compontentsData[item].communications[0].ip != ""
      ) {
        compontentsData[item].communications[0].ip =
          defaultIpAddress[`ifeIpAddress${ipCount}`];

        if (index === 0) {
          compontentsData[item].communications[0].modbusSlaveId = "255";
        } else if (
          index > 0 &&
          compontentsData[item].communications[0].modbusSlaveId === "255" &&
          index % value === 0
        ) {
          // compontentsData[item].communications[0].modbusSlaveId = cBMBData["modbusId_" + compontentsData[item].componentIdx];
        }
        if (ipIterated) {
          compontentsData[item].communications[0].modbusSlaveId = "255";
          modCount = modCount + 1;
        } else if (
          compontentsData[item].communications[0].modbusSlaveId === "255"
        ) {
          compontentsData[item].communications[0].modbusSlaveId =
            cBMBData["modbusId_" + compontentsData[item].componentIdx];
        }
        if (
          index !== 0 &&
          compontentsData[item].communications[0].modbusSlaveId !== "255" &&
          !ipIterated
        ) {
          doModBusChange = true;
          console.log(modCount);
          compontentsData[item].communications[0].modbusSlaveId = modCount;
          modCount = modCount + 1;
        }

        ipIterated = false;
        if (
          (index + 1) % value == 0 ||
          (indexes?.[data]?.cbArray?.length > 0 &&
            index + 1 == indexes?.[data]?.cbArray?.length)
        ) {
          ipCount++;
          ipIterated = true;
          modCount = 0;
        }
      }
    });
  }
  return compontentsData;
}

function groupCB(
  data = [],
  CBAssetList = [],
  CBLoadList = [],
  CBEVList = [],
  assetDefaultValues
) {
  const groupCB = {
    ife1: { cbValue: 1, cbArray: [] },
    ife2: { cbValue: 2, cbArray: [] },
    ife3: { cbValue: 3, cbArray: [] },
    ife4: { cbValue: 4, cbArray: [] },
    ife5: { cbValue: 5, cbArray: [] },
    ife6: { cbValue: 6, cbArray: [] },
    ife7: { cbValue: 7, cbArray: [] },
  };
  let remotePms = [];
  data.forEach((item, index) => {
    if (!item) {
      return;
    }
    const pmAttr = JSON.parse(item?.uiAttributes || "{}");
    if (pmAttr?.isRemoteLoad) {
      let loadCalled = true;
      CBLoadList?.forEach((loadData, ind) => {
        if (item?.componentType === "Power Meter") {
          if (loadData.uiData.isRemoteLoad && loadCalled) {
            console.log(assetDefaultValues);
            remotePms.push(
              assetDefaultValues["Power Meter"][
                "ipAddress_PM_Load" + (remotePms.length + 1)
              ]
            );

            item.communications[0].ip =
              assetDefaultValues["Power Meter"][
                "ipAddress_PM_Load" + (remotePms.length + 1)
              ];
            loadCalled = false;
          }
        }
      });
    }
    if (
      item?.componentType === "Circuit Breaker" &&
      item?.communications?.[0]?.ip != "" &&
      item
    ) {
      CBAssetList?.length > 0 &&
        CBAssetList?.forEach((cbData) => {
          if (cbData?.cbConfigData?.name == item?.componentName) {
            for (let i in groupCB) {
              if (
                cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]
                  ?.value == groupCB[i].cbValue
              ) {
                groupCB?.[i]?.cbArray.push(index);
              }
            }
          }
        });
      CBEVList?.forEach((evData) => {
        if (evData?.cbConfigData?.name == item?.componentName) {
          for (let i in groupCB) {
            if (
              evData?.cbConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]
                ?.value == groupCB[i].cbValue
            ) {
              groupCB?.[i]?.cbArray.push(index);
            }
          }
        }
      });
      CBLoadList?.forEach((loadData) => {
        if (loadData?.cbConfigData?.name == item?.componentName) {
          for (let i in groupCB) {
            if (
              loadData?.cbConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]
                ?.value == groupCB[i].cbValue
            ) {
              groupCB?.[i]?.cbArray.push(index);
            }
          }
        }
      });
    }
    const uiAttributes = JSON.parse(item?.uiAttributes || "{}");
    if (uiAttributes?.contactor == false) {
      delete uiAttributes?.contactor;
      data[index].uiAttributes = JSON.stringify(uiAttributes);
    }
  });
  return groupCB;
}
